"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const enum_1 = require("./enum");
// import { SoftDeleteModel, softDeletePlugin } from "soft-delete-plugin-mongoose";
const LogSchema = new mongoose_1.Schema({
    name: String,
    key: String,
    commit: Object,
    status: {
        type: String,
        enum: Object.values(enum_1.PROJECT_STATUS),
        default: enum_1.PROJECT_STATUS.PENDING,
    },
    project: {
        ref: "Project",
        type: mongoose_1.Schema.Types.ObjectId,
    },
    user: {
        ref: "User",
        type: mongoose_1.Schema.Types.ObjectId,
    },
    team: {
        ref: "Team",
        type: mongoose_1.Schema.Types.ObjectId,
    },
    preview: {
        ref: "Preview",
        type: mongoose_1.Schema.Types.ObjectId,
    },
    environment: {
        type: String,
        enum: Object.values(enum_1.ENVIRONMENT),
        default: enum_1.ENVIRONMENT.PRODUCTION,
    },
    jobs: Array,
    startTime: mongoose_1.Schema.Types.Date,
    endTime: mongoose_1.Schema.Types.Date,
    deleted: mongoose_1.Schema.Types.Boolean,
}, { timestamps: true });
// LogSchema.plugin(softDeletePlugin);
exports.default = (0, mongoose_1.model)("Log", LogSchema);
